import React from 'react';
import Game from 'screens/Game/';

function App() {
  return <Game />;
}

export default App;
